interface HamburgerButtonProps {
    isOpen: boolean
    onClick: () => void
}

export function HamburgerButton({ isOpen, onClick }: HamburgerButtonProps) {
    return (
        <button
            onClick={onClick}
            aria-label="Toggle navigation"
            aria-expanded={isOpen}
            className="flex flex-col justify-center items-center w-6 h-6 focus:outline-none"
        >
            <span
                className={`block w-5 h-0.5 bg-gray-700 dark:bg-gray-300 transition-all duration-300 ${isOpen ? 'rotate-45 translate-y-1.5' : ''
                    }`}
            />
            <span
                className={`block w-5 h-0.5 bg-gray-700 dark:bg-gray-300 transition-all duration-300 my-1 ${isOpen ? 'opacity-0' : ''
                    }`}
            />
            <span
                className={`block w-5 h-0.5 bg-gray-700 dark:bg-gray-300 transition-all duration-300 ${isOpen ? '-rotate-45 -translate-y-1.5' : ''
                    }`}
            />
        </button>
    )
}
